/**
 * SQLSTATE codes our RPCs raise to say "the row changed; reload and try again".
 *
 * PT409 is current: PostgREST maps it to HTTP 409 and never retries it. 40001
 * (serialization_failure) is accepted for direct-Postgres callers, but an RPC must never
 * RAISE it: PostgREST retries 40001 with no retry limit, so a business conflict that never
 * clears loops forever (2026-10-14: 8.5M postgres errors in 24h).
 */
export const CONFLICT_SQLSTATES: ReadonlySet<string> = new Set(['PT409', '40001']);

export function isConflictCode(code: string | null | undefined): boolean {
  return !!code && CONFLICT_SQLSTATES.has(code);
}
